export class Statistiche {
    public redcards: number = null;
    public assists: number = null;
    public goals: number = null;
    public yellowcards: number = null;
    public owngoals: number = null;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/statistiche.ts